// extracted by mini-css-extract-plugin
module.exports = {"divCentro":"Cursos_divCentro__3cbq2"};